import React from 'react'

function control(options) {
    const defaultValue = options.value

    return (Component) => {

        class ControlConnector extends React.Component {

            constructor(props) {
                super(props)

                this.state = {
                    value: props.value || defaultValue
                }
            }

            componentWillReceiveProps(nextProps) {
                if (nextProps.value != this.props.value) {
                    this.setState({
                        value: nextProps.value || defaultValue
                    })
                }
            }

            render() {
                return <Component {...this.props} {...this.state} />
            }
        }

        return ControlConnector
    }
}

export {control}


// WEBPACK FOOTER //
// ./lib/core/react/control.js